<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAppleLogo_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M12.952 10.974q-.279.644-.66 1.188-.523.743-.852 1.028-.509.469-1.093.482-.42 0-1.01-.241-.591-.24-1.088-.24-.52 0-1.118.24-.598.242-.966.254-.561.024-1.119-.495-.356-.31-.89-1.064a7.4 7.4 0 0 1-.94-1.87 6.8 6.8 0 0 1-.396-2.228q0-1.235.534-2.128.42-.717 1.12-1.132a3 3 0 0 1 1.512-.427q.445.001 1.17.272.724.272.928.273.153 0 1.03-.321.826-.297 1.398-.249 1.551.125 2.327 1.225-1.387.84-1.373 2.352.014 1.176.852 1.954a2.8 2.8 0 0 0 .85.558q-.102.296-.216.57m-2.37-9.328q0 .922-.673 1.719c-.54.631-1.193.996-1.901.938a2 2 0 0 1-.014-.232c0-.59.256-1.222.712-1.738q.342-.391.869-.652.526-.256.993-.281.014.123.013.246"
    />
</svg>
